"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullableNumberRangeAggregator = exports.numberRangeAggregator = exports.numbersAggregate = void 0;
const field_logic_1 = require("../field-type-registry/field-logic");
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
/**
 * Aggregator that processes only filled in float values.
 */
function numbersAggregate(aggregate) {
    return (records = [], field, targetOfField, userPreferences) => {
        // For lookup field we need to calculate aggregate separately
        // because lookup value is array of data and valuesAggregator flat this data by default.
        // According to the requirements, we must first aggregate the values in the records
        // and then aggregate the resulting values.
        // E.g. [5, 15], [25] -> median(median(5, 15), median(25)) = 17.5
        if ((targetOfField === null || targetOfField === void 0 ? void 0 : targetOfField.field_type) === "lookupfield") {
            const targetOfFieldLogic = (0, fields_logic_registry_1.getFieldLogic)(targetOfField.field_type);
            const numbers = records
                .map((record) => {
                const lookupValue = targetOfFieldLogic.getFieldValueFromRecord(record, targetOfField);
                const targetNumbers = toNonEmptyNumbers(lookupValue.flat(2), field);
                return aggregate(targetNumbers);
            })
                .filter(isNumber);
            const result = aggregate(numbers);
            if (result === null) {
                return null;
            }
            return (0, fields_logic_registry_1.getFieldLogic)(field.field_type).getAggregateDisplayValue(String(result), field, userPreferences);
        }
        return (0, field_logic_1.valuesAggregator)((values, fieldLogic) => {
            const numbers = toNonEmptyNumbers(values, field);
            const result = aggregate(numbers);
            if (result === null) {
                return null;
            }
            return fieldLogic.getAggregateDisplayValue(String(result), field, userPreferences);
        })(records, field, targetOfField, userPreferences);
    };
}
exports.numbersAggregate = numbersAggregate;
function numberRangeAggregator(...props) {
    const min = numbersAggregate((values) => values.length ? Math.min(...values) : null)(...props);
    const max = numbersAggregate((values) => values.length ? Math.max(...values) : null)(...props);
    return min !== null && max !== null ? `${min} - ${max}` : null;
}
exports.numberRangeAggregator = numberRangeAggregator;
function nullableNumberRangeAggregator(...props) {
    const min = numbersAggregate((values) => values.length ? Math.min(...values) : 0)(...props);
    const max = numbersAggregate((values) => values.length ? Math.max(...values) : 0)(...props);
    return `${min !== null && min !== void 0 ? min : 0} - ${max !== null && max !== void 0 ? max : 0}`;
}
exports.nullableNumberRangeAggregator = nullableNumberRangeAggregator;
function toNonEmptyNumbers(values, field) {
    var _a;
    const toNumber = (_a = toNumberMap[field.field_type]) !== null && _a !== void 0 ? _a : ((value) => parseFloat(String(value)));
    return values
        .filter((value) => value !== null && value !== undefined && value !== "")
        .map(toNumber);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toNumberMap = {
    timetrackingfield: (value) => { var _a; return (_a = value.total_duration) !== null && _a !== void 0 ? _a : 0; },
};
function isNumber(value) {
    return typeof value === "number";
}
